import React, { useState, useEffect } from "react";

import { Transaction_Profile } from "../../Connections/Transaction";
import Toast from "../../Utils/Toast";
import "../../Styles/History.css";

const History = ({ close }) => {
  const [bill, setBill] = useState([]);

  //  =================================================

  useEffect(() => {
    Transaction_Profile.GetTransfers()
      .then((res) => {
        if (res[0]) {
          setBill(res[2].data);
        } else {
          Toast("error", "مشکلی پیش آمده است!");
        }
      })
      .catch((err) => console.log(err));
  }, []);

  //  =================================================

  return (
    <div className="wallet-wrapper">
      <div className="History">
        <div className="History-inside">
          <div className="History-inside-item1">
            <div className="History-inside-item1-text">
              <p className="History-inside-item1-text-p">تاریخچه تراکنش</p>
            </div>

            <div className="History-inside-item1-image" onClick={close}>
              <img
                className="History-inside-item1-image-img"
                src="imgs/Profile/Icon.svg"
              />
            </div>
          </div>
          {bill.reverse().map((item) => (
            <div className="History-inside-item2" key={item.id}>
              <div className="History-inside-item2-top">
                {item.transactionType == "Income" ? (
                  <>
                    <div className="History-inside-item2-top-image">
                      <img
                        className="History-inside-item2-top-image-img"
                        src="imgs/Profile/wallet.svg"
                      />
                    </div>
                    <p className="History-inside-item2-top-text">
                      شارژ کیف پول
                    </p>
                    <img
                      style={{ height: "25px", marginRight: "3px" }}
                      src="imgs/Profile/recive-money.png"
                      alt="recive-money"
                    />
                  </>
                ) : item.transactionType == "Transfer" ? (
                  <>
                    <div className="History-inside-item3-top-image">
                      <img
                        className="History-inside-item3-top-image-img"
                        src="imgs/Profile/wallet.svg"
                      />
                    </div>
                    <p className="History-inside-item3-top-text">انتقال</p>
                  </>
                ) : (
                  <>
                    <div className="History-inside-item3-top-image">
                      <img
                        className="History-inside-item3-top-image-img"
                        src="imgs/Profile/Sabad.svg"
                      />
                    </div>
                    <p className="History-inside-item3-top-text">خرید کتاب</p>
                    <img
                      style={{ height: "25px", marginRight: "3px" }}
                      src="imgs/Profile/send-money.png"
                      alt="send-money"
                    />
                  </>
                )}
              </div>

              <div className="History-inside-item2-bottom">
                <div className="History-inside-item2-bottom-item1">
                  <div className="History-inside-item2-bottom-item1-right">
                    <p className="History-inside-item2-bottom-item1-right-text">
                      مبلغ تراکنش
                    </p>
                  </div>
                  <div className="History-inside-item2-bottom-item1-left">
                    <p className="History-inside-item2-bottom-item1-left-text">
                      <span className="History-inside-item2-bottom-item1-left-Money number-font">
                        {item.price}
                      </span>
                      تومان
                    </p>
                  </div>
                </div>

                <div className="History-inside-item2-bottom-item2">
                  <div className="History-inside-item2-bottom-item2-right">
                    <p className="History-inside-item2-bottom-item2-right-text">
                      تاریخ تراکنش
                    </p>
                  </div>
                  <div className="History-inside-item2-bottom-item2-left">
                    <p className="History-inside-item2-bottom-item2-left-time number-font">
                      {`${item.date.split("|")[1]} | ${
                        item.date.split("|")[0]
                      }`}
                    </p>
                  </div>
                </div>

                <div className="History-inside-item2-bottom-item3">
                  <div className="History-inside-item2-bottom-item3-right">
                    <p className="History-inside-item2-bottom-item3-right-text">
                      کد رهگیری
                    </p>
                  </div>
                  <div className="History-inside-item2-bottom-item3-left">
                    <p className="History-inside-item2-bottom-item3-left-code number-font">
                      {item.refId}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default History;
